import type { ReduxState } from 'app/redux/types';

import type { MyStakesState } from '../reducer';
import type { ActiveStakesState } from '../types/activeStakes';
import type { CashOutStakesState } from '../types/cashOutStakes';
import type { InformationTileState } from '../types/informationTile';
import type { SidebarPreferencesState } from '../types/sidebarPreferences';

// ---

export const selectMyStakes = (state: ReduxState): MyStakesState => {
  return state.myStakes;
};

export const selectActiveStakes = (state: ReduxState): ActiveStakesState => {
  return selectMyStakes(state).activeStakes;
};

export const selectInformationTile = (state: ReduxState): InformationTileState => {
  return selectMyStakes(state).informationTile;
};

export const selectSidebarPreferences = (state: ReduxState): SidebarPreferencesState => {
  return selectMyStakes(state).sidebarPreferences;
};

export const selectCashOutStakes = (state: ReduxState): CashOutStakesState => {
  return selectMyStakes(state).cashOutStakes;
};
